/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Fact_IndustryInputs */

const en_project_fact_industry = /** @type {(inputs: Project_Fact_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry`)
};

const lv_project_fact_industry = /** @type {(inputs: Project_Fact_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nozare`)
};

/**
* | output |
* | --- |
* | "Industry" |
*
* @param {Project_Fact_IndustryInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_fact_industry = /** @type {((inputs?: Project_Fact_IndustryInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Fact_IndustryInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_fact_industry(inputs)
	return en_project_fact_industry(inputs)
});